export const ACTIVATION_PRODUCT_INITIAL_STATE = {
  activationLink: null,
  product: null,
}
